import { uniq } from 'es-toolkit/compat';
import {
  ALL_OFFERING_SINGLE_SLUGS_CONSUMER,
  OfferingSingleSlugConsumer,
} from './singleSlugConsumer';
import {
  ALL_OFFERING_SINGLE_SLUGS_DASHBOARD,
  OfferingSingleSlugDashboard,
} from './singleSlugDashboard';

export function offeringSlugDashboardRoutePattern(
  pathVar: string,
  limitTo: OfferingSingleSlugDashboard[] = ALL_OFFERING_SINGLE_SLUGS_DASHBOARD
): string {
  return `:${pathVar}(${uniq(limitTo).join('|')})`;
}

export function offeringSlugConsumerRoutePattern(
  pathVar: string,
  limitTo: OfferingSingleSlugConsumer[] = ALL_OFFERING_SINGLE_SLUGS_CONSUMER
): string {
  return `:${pathVar}(${uniq(limitTo).join('|')})`;
}
